import { ON_NAVIGATION } from '@state/actions/appActions'
import {
  ADD_BREADCRUMB,
  REPLACE_BREADCRUMB_AT_INDEX,
  UPDATE_BREADCRUMBS,
} from '@state/actions/breadcrumbsActions'

/**
 * Initial state
 */
const initialBreadcrumbsState = {
  breadcrumbs: [],
  newBreadcrumb: undefined,
  currentLocation: undefined,
}

const resetRoutes = ['', 'bibliotek', 'bokhylla', 'lararrum', 'profil', 'hjalp']
const linkNameMap = {
  bokhylla: 'Min bokhylla',
  bibliotek: 'Bibliotek',
  lararrum: 'Mitt lärarrum',
  profil: 'Inställningar',
  hjalp: 'Hjälp',
}
const routeBreadcrumbsLength = {
  bokhylla: 1,
  bibliotek: 1,
  lararrum: 2,
  profil: 1,
  hjalp: 1,
}

/**
 * Reducer
 */
const breadcrumbsReducer = (state, action) => {
  var breadcrumbs = [...state.breadcrumbs]

  switch (action.type) {
    case UPDATE_BREADCRUMBS:
      var pathArray = state.currentLocation.pathname.split('/').slice(1)

      if (
        !resetRoutes.includes(pathArray[0]) &&
        window.history.state?.breadcrumbs
      ) {
        // Restore breadcrumbs from history (user reloaded page or used browser navigation)

        breadcrumbs = window.history.state?.breadcrumbs ?? []
      } else if (state.currentLocation.state?.restoreBreadcrumbs?.length) {
        // Navigate with breadcrumbs

        breadcrumbs = state.currentLocation.state?.restoreBreadcrumbs
      } else {
        // Add new breadcrumb

        if (state.currentLocation.state?.replaceLastBreadcrumb) {
          breadcrumbs = [...breadcrumbs.slice(0, breadcrumbs.length - 1)]
        }

        let breadcrumbsLength = breadcrumbs[0]?.breadcrumbsLength ?? 0
        if (breadcrumbs.length > breadcrumbsLength) {
          breadcrumbs = [...breadcrumbs.slice(0, breadcrumbsLength)]
        }

        breadcrumbs = [...breadcrumbs, state.newBreadcrumb]

        window.history.replaceState({ breadcrumbs }, '')
      }

      return {
        ...state,
        breadcrumbs,
        newBreadcrumb: undefined,
        currentLocation: undefined,
      }

    case ON_NAVIGATION:
      var location = action?.payload?.location
      pathArray = location?.pathname.split('/').slice(1)

      if (resetRoutes.includes(pathArray[0])) {
        breadcrumbs =
          pathArray[0] === ''
            ? []
            : [
                {
                  link: '/' + pathArray[0],
                  label: linkNameMap?.[pathArray[0]],
                  breadcrumbsLength: routeBreadcrumbsLength[pathArray[0]],
                },
              ]
      }

      return {
        ...state,
        breadcrumbs,
        currentLocation: location,
      }

    case ADD_BREADCRUMB:
      return {
        ...state,
        newBreadcrumb: action.payload,
      }

    case REPLACE_BREADCRUMB_AT_INDEX: {
      const { index, newBreadcrumb } = action.payload

      // Ensure the index is within bounds
      if (index >= 0 && index < breadcrumbs.length) {
        // Replace the breadcrumb at the specified index
        breadcrumbs = [
          ...breadcrumbs.slice(0, index), // keep items before the index
          newBreadcrumb, // replace item at the index
          ...breadcrumbs.slice(index + 1), // keep items after the index
        ]
      }

      return {
        ...state,
        breadcrumbs,
      }
    }
    default:
      return state
  }
}

export { breadcrumbsReducer, initialBreadcrumbsState }
